import { Add, ArrowBack, Delete, Save } from '@mui/icons-material';
import { Box, Button, Icon, IconButton, Paper, Theme, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { useAuthContext } from '../../../context';
import { useNavigate } from 'react-router-dom';

interface IToolsDetailsProps {
    showNewButton?: boolean;
    showBackButton?: boolean;
    showDeletButton?: boolean;
    showSaveButton?: boolean;
    showSaveCloseButton?: boolean;

    onClickNew?: () => void;
    onClickDelet?: () => void;
    onClickSave?: () => void;
    onClickSaveClose?: () => void;

    disableSave?: boolean;
}

export const ToolsDetails: React.FC<IToolsDetailsProps> = ({
    showDeletButton = true,
    showSaveButton = true,
    showNewButton = true,
    showBackButton = true, 
    disableSave,
    onClickDelet,
    onClickSave,
    onClickNew,
}) => {
    const smDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
    const { userData } = useAuthContext();
    const theme = useTheme();
    const navigate = useNavigate(); 

    const handleBack = () => {
        navigate(-1);
    };

    return (
        <Box
            component={Paper}
            height={theme.spacing(4)}
            marginX={1}
            paddingX={2}
            padding={1}
            display={'flex'}
            gap={2}
            alignItems={'center'}
            borderRadius={2}
        >
            {showNewButton && userData.permissoes.includes('add') && (
                <>
                    {smDown ? (
                        <>
                            <IconButton onClick={onClickNew}>
                                <Add color="primary" />
                            </IconButton>
                        </>
                    ) : (
                        <>
                            <Button
                                variant="contained"
                                disableElevation
                                onClick={onClickNew}
                                startIcon={<Add />}
                                sx={{ borderRadius: '25px' }}
                            >
                                <Typography variant="button" whiteSpace={'nowrap'} textOverflow={'ellipsis'} overflow={'hidden'}>
                                    Novo
                                </Typography>
                            </Button>
                        </>
                    )}
                </>
            )}

            {showDeletButton && userData.permissoes.includes('remove') && (
                <>
                    {smDown ? (
                        <>
                            <IconButton onClick={onClickDelet}>
                                <Delete color="primary" />
                            </IconButton>
                        </>
                    ) : (
                        <>
                            <Button
                                variant="contained"
                                disableElevation
                                onClick={onClickDelet}
                                startIcon={<Delete />}
                                sx={{ borderRadius: '25px' }}
                            >
                                <Typography variant="button" whiteSpace={'nowrap'} textOverflow={'ellipsis'} overflow={'hidden'}>
                                    Apagar
                                </Typography>
                            </Button>
                        </>
                    )}
                </>
            )}

            {showSaveButton && userData.permissoes.includes('edit') && (
                <>
                    {smDown ? (
                        <>
                            <IconButton onClick={onClickSave}>
                                <Save color="primary" />
                            </IconButton>
                        </>
                    ) : (
                        <>
                            <Button
                                variant="contained"
                                disableElevation
                                onClick={onClickSave}
                                startIcon={<Save />}
                                sx={{ borderRadius: '25px' }}
                                disabled={disableSave}
                            >
                                <Typography variant="button" whiteSpace={'nowrap'} textOverflow={'ellipsis'} overflow={'hidden'}>
                                    Salvar
                                </Typography>
                            </Button>
                        </>
                    )}
                </>
            )}

            <Box flex={1} display={'flex'} justifyContent={'end'} gap={1} marginLeft={2}>
                {showBackButton && (
                    <>
                        {smDown ? (
                            <>
                                <IconButton
                                    onClick={handleBack} 
                                >
                                    <ArrowBack />
                                </IconButton>
                            </>
                        ) : (
                            <>
                                <Button
                                    variant="contained"
                                    disableElevation
                                    startIcon={<Icon>arrow_back</Icon>}
                                    size="small"
                                    onClick={handleBack} 
                                    sx={{ borderRadius: '25px' }}
                                >
                                    <Typography variant="button" whiteSpace={'nowrap'} textOverflow={'ellipsis'} overflow={'hidden'}>
                                        Voltar
                                    </Typography>
                                </Button>
                            </>
                        )}
                    </>
                )}
            </Box>
        </Box>
    );
};